<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [header]="dialogTitle"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving"
  [closeOnEscape]="!saving"
  [style]="{ width: 'min(980px, 94vw)' }"
  [breakpoints]="{ '860px': '96vw' }"
  styleClass="master-create-dialog field-work-create-dialog">
  <section class="master-dialog-body">
    <aside class="master-dialog-summary">
      <div class="summary-icon"><i class="pi pi-briefcase"></i></div>
      <div>
        <small>Field Resources</small>
        <h3>Plan an operational activity</h3>
        <p>{{ dialogDescription }}</p>
      </div>
      <div class="master-dialog-facts">
        <div><span>Target</span><strong>{{ targetLabel }}</strong></div>
        <div><span>Activity</span><strong>{{ selectedActivityLabel }}</strong></div>
        <div><span>Location</span><strong>{{ selectedLocationLabel }}</strong></div>
      </div>
    </aside>

    <form [formGroup]="form" class="master-dialog-form" (ngSubmit)="submit()">
      <p-inputGroup class="master-wide-field">
        <p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
        <p-iftalabel>
          <input id="fieldWorkTitle" pInputText formControlName="title" />
          <label for="fieldWorkTitle">Title *</label>
        </p-iftalabel>
      </p-inputGroup>

      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-list-check"></i></p-inputGroupAddon>
        <p-iftalabel>
          <p-select inputId="fieldWorkActivity" formControlName="activityType" [options]="activityOptions"
            optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
          <label for="fieldWorkActivity">Activity *</label>
        </p-iftalabel>
      </p-inputGroup>

      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
        <p-iftalabel>
          @if (locationOptions !== undefined) {
            <p-select inputId="fieldWorkLocation" formControlName="locationId" [options]="locations"
              optionLabel="name" optionValue="id" [filter]="true"
              filterBy="name,fieldWorkLabel,stopType,stopNumber,longDescription,shortDescription,externalLocationReference"
              appendTo="body" styleClass="w-full">
              <ng-template let-location pTemplate="item">{{ locationLabel(location) }}</ng-template>
              <ng-template let-location pTemplate="selectedItem">{{ locationLabel(location) }}</ng-template>
            </p-select>
          } @else {
            <p-select inputId="fieldWorkLocation" formControlName="locationId" appLazyLocationPicker
              optionLabel="name" optionValue="id" [filter]="true"
              filterBy="name,longDescription,shortDescription,externalLocationReference"
              appendTo="body" styleClass="w-full" (onChange)="onLazyLocationSelected($event.value)">
              <ng-template let-location pTemplate="item">{{ locationLabel(location) }}</ng-template>
              <ng-template let-location pTemplate="selectedItem">{{ locationLabel(location) }}</ng-template>
            </p-select>
          }
          <label for="fieldWorkLocation">Location *</label>
        </p-iftalabel>
      </p-inputGroup>

      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
        <p-iftalabel>
          <p-datepicker inputId="fieldWorkStart" formControlName="plannedStart" dateFormat="mm/dd/yy"
            [showTime]="true" hourFormat="12" [showButtonBar]="true" appendTo="body"
            styleClass="w-full"></p-datepicker>
          <label for="fieldWorkStart">Start *</label>
        </p-iftalabel>
      </p-inputGroup>

      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-calendar-clock"></i></p-inputGroupAddon>
        <p-iftalabel>
          <p-datepicker inputId="fieldWorkEnd" formControlName="plannedEnd" dateFormat="mm/dd/yy"
            [showTime]="true" hourFormat="12" [showButtonBar]="true" [minDate]="minimumEndDate"
            appendTo="body" styleClass="w-full"></p-datepicker>
          <label for="fieldWorkEnd">End *</label>
        </p-iftalabel>
      </p-inputGroup>

      <p-inputGroup class="master-wide-field">
        <p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
        <p-iftalabel>
          <p-select inputId="fieldWorkBillable" formControlName="billable" [options]="yesNo"
            optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
          <label for="fieldWorkBillable">Billable *</label>
        </p-iftalabel>
      </p-inputGroup>

      @if (submittedOnce && form.hasError('invalidSchedule')) {
        <small class="p-error master-wide-field">End time must be later than start time.</small>
      }
      @if (submittedOnce && form.invalid && !form.hasError('invalidSchedule')) {
        <small class="p-error master-wide-field">Complete all required work-package fields.</small>
      }
      @if (error) {
        <div class="dialog-error master-wide-field"><i class="pi pi-exclamation-circle"></i><span>{{ error }}</span></div>
      }
    </form>
  </section>

  <ng-template pTemplate="footer">
    <div class="master-dialog-footer">
      <p-button type="button" label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true"
        [disabled]="saving" (click)="reset()"></p-button>
      <span class="footer-spacer"></span>
      <p-button type="button" label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
        [disabled]="saving" (click)="close()"></p-button>
      <p-button type="button" [label]="submitLabel" [icon]="submitIcon" [loading]="saving"
        (click)="submit()"></p-button>
    </div>
  </ng-template>
</p-dialog>
